'use client';

import { OrganizationDeleteSection } from '../../components/OrganizationProfile/OrganizationGeneralPage';
import { createSection } from '../createSection';

export const OrganizationProfileDeleteSection = createSection(
  'OrganizationProfileDeleteSection',
  OrganizationDeleteSection,
);
